import { useTreeStore } from "@/lib/stores/treeStore";
import AddIcon from "@mui/icons-material/Add";
import { Button, ButtonProps } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
interface CreateTreeButtonProps extends Omit<ButtonProps, "onClick"> {
  minWidth?: number;
  navigateTo?: string;
}

/**
 * A button component for creating a new decision tree
 */
export const CreateTreeButton: React.FC<CreateTreeButtonProps> = ({
  minWidth = 200,
  navigateTo = "/trees",
  ...buttonProps
}) => {
  const { clearCurrentTree } = useTreeStore();
  const { isAuthenticated, hasActiveSubscription } = useAuth();

  const navigate = useNavigate();
  const handleCreateNew = () => {
    if (!isAuthenticated) {
      navigate("/login");
      return;
    }

    if (!hasActiveSubscription) {
      // If user is authenticated but not subscribed, send to subscription page
      navigate("/subscription");
      return;
    }

    clearCurrentTree();
    navigate("/editor"); // replace with navigateTo when ready
  };

  return (
    <Button
      variant="contained"
      startIcon={<AddIcon />}
      onClick={handleCreateNew}
      sx={{ minWidth, backgroundColor: "primary.main", ...buttonProps.sx }}
      {...buttonProps}
    >
      {isAuthenticated ? "Create New Tree" : "Sign In to Create Tree"}
    </Button>
  );
};
